import axios from '@/api/config'

const log = {
  getLogById (data) {
    return axios.get(`${process.env.BASE_URL}/log/getLog/` + data, {})
  },
  getLog (data) {
    return axios.get(`${process.env.BASE_URL}/log/getLog`, {params: data})
  },
  getLogList (data) {
    return axios.get(`${process.env.BASE_URL}/log/getLogList`, {params: data})
  },
  getLogTree (data) {
    return axios.get(`${process.env.BASE_URL}/log/getLogTree`, {params: data})
  },
  pageList (data) {
    return axios.post(`${process.env.BASE_URL}/log/pageList`, data)
  },
  addLog (data) {
    return axios.post(`${process.env.BASE_URL}/log/addLog`, data)
  },
  updateLog (data) {
    return axios.put(`${process.env.BASE_URL}/log/updateLog`, data)
  },
  deleteLog (data) {
    return axios.delete(`${process.env.BASE_URL}/log/deleteLog`, {data: data})
  },
  exportExcel (data) {
    return axios.get(`${process.env.BASE_URL}/log/exportExcel`, {params: data})
  },
  importData (data) {
    return axios.post(`${process.env.BASE_URL}/log/importData`, data)
  },
}

export default log



// WEBPACK FOOTER //
// ./src/api/log.js